module.exports = __webpack_public_path__ + "img/shiLin2.7ca70986.png";